import * as React from "react"
import { Route, Switch } from "react-router-dom"
import Loadable from "@bappweb/loadable"
import Header from "@smpu-web/globalmodules/header"
import Footer from "@smpu-web/globalmodules/footer"
import Landing from "./landing"
import Block from "@bappweb/block"
import { useAppDispatch, useAppSelector } from "../config/hook"
import StickyHeader from "./landing/main/stickyheader"
import { BAPPgetElementById } from "@bappweb/utils"
import { setSessionData } from "../state/sessionData"
import { useGetConfigListMutation } from "../api/services"
import { setIsStickActive } from "../state/isStickyActive"
import { getCidParameter, getConfigValue } from "@smpu-web/utils/utils"

const Main = () => {
  const dispatch = useAppDispatch()
  const routes = React.useMemo(
    () => ({
      Landing,
      Details: () => <Loadable loader={() => import("./details")} />,
      Result: () => <Loadable loader={() => import("./result")} />,
      // eslint-disable-next-line react/no-multi-comp
      NotFound: () => <Loadable loader={() => import("./not-found-404")} />
    }),
    []
  )

  const sessionData = useAppSelector((state) => state.sessionData.response)

  const [scrollPosition, setScrollPositon] = React.useState(false)
  const [isLanding, setIsLanding] = React.useState(BAPPgetElementById("form1"));
  const [getConfigList] = useGetConfigListMutation();

  React.useEffect(() => {
    getConfigList({
      functionCode: "MERC001",
      cid: getCidParameter() ?? "",
      TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF"
    })
      .unwrap()
      .then((payload) => {
        if (!payload.IsError) {
          dispatch(
            setSessionData({
              configList: payload.configList
            })
          )
        }
      })
  }, [])

  React.useEffect(() => {
    window.addEventListener('scroll', () => {
      setIsLanding(BAPPgetElementById("form1"))
      if (isLanding) {
        if (document.documentElement.scrollTop > 400) {
          setScrollPositon(true)
          dispatch(
            setIsStickActive({
              isStickyActive: true
            })
          )
        } else {
          setScrollPositon(false)
          dispatch(
            setIsStickActive({
              isStickyActive: false
            })
          )
        }
      }
    })
  }, [document.documentElement.scrollTop])

  return (
    <>
      <Block type="main" className="bapp-main bapp-main-container">
        {scrollPosition && isLanding && <StickyHeader campaigns={getConfigValue(sessionData?.configList, "PosBasvuru.Landing.Top")} />}
        {sessionData?.isDetailsPage && <Header />}
        <Switch>
          <Route exact path="/" component={routes.Landing} />
          <Route path="/details/*" component={routes.Details} />
          <Route path="/result/*" component={routes.Result} />
          <Route component={routes.NotFound} />
        </Switch>
        <Footer />
      </Block>

    </>
  )
}

export default Main
